// Small numeric helpers for the Issue Analytics page.

// Wilson score interval for a binomial proportion (95% by default). Used to rank
// reject rates so that one discard out of two issues does not outrank a steady 15%
// over thousands: "worst first" sorts by the lower bound, "best first" by the upper.
export function wilsonInterval(successes, n, z = 1.96) {
  if (!n || n <= 0) return { p: null, low: null, high: null };
  const p = successes / n;
  const z2 = z * z;
  const denom = 1 + z2 / n;
  const center = (p + z2 / (2 * n)) / denom;
  const half = (z * Math.sqrt((p * (1 - p)) / n + z2 / (4 * n * n))) / denom;
  return { p, low: Math.max(0, center - half), high: Math.min(1, center + half) };
}

export function pct(numer, denom) {
  if (!denom) return 0;
  return numer / denom;
}

export function fmtPct(p, digits = 1) {
  if (p == null || Number.isNaN(p)) return "n/a";
  return `${(p * 100).toFixed(digits)}%`;
}

// "9–17%" style range for a Wilson interval.
export function fmtRange(low, high) {
  if (low == null || high == null) return "";
  return `${Math.round(low * 100)}–${Math.round(high * 100)}%`;
}

// 0 = green (no discards), 1 = red (everything discarded). null/undefined → neutral.
export function heatColor(rate) {
  if (rate == null || Number.isNaN(rate)) return "rgba(0,0,0,0.04)";
  const r = Math.round(31 + (239 - 31) * rate);
  const g = Math.round(175 - (175 - 68) * rate);
  const b = Math.round(92 - (92 - 68) * rate);
  return `rgb(${r},${g},${b})`;
}

// Volume floors offered by the "Min. issues" filter.
export const MIN_VOLUME_OPTIONS = [0, 10, 25, 50, 100, 250];

// Weekly reject-rate points need a few issues before the rate means anything.
export const MIN_ISSUES_PER_POINT = 5;

// Monday (UTC) of the ISO week containing the timestamp, as YYYY-MM-DD.
export function weekStartOf(value) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const day = d.getUTCDay(); // 0 = Sunday
  const diff = (day + 6) % 7;
  const monday = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() - diff));
  return monday.toISOString().slice(0, 10);
}
